"use client";
import {
  cn,
  getFlexItems,
  getFlexJustify,
  getSpacing,
} from "@/lib/utils/utils";
import {
  DirectionalSpacing,
  FlexDirection,
  FlexItems,
  FlexJustify,
  FlexMode,
  FlexWrap,
} from "@/types/core";

interface FlexProps extends React.PropsWithChildren {
  className?: string;
  fullWidth?: boolean;
  fullHeight?: boolean;
  mode?: FlexMode;
  direction?: FlexDirection;
  justify?: FlexJustify;
  items?: FlexItems;
  flexWrap?: FlexWrap;
  spacing?: DirectionalSpacing;
  center?: boolean;
  asContainer?: boolean;
}

const Flex: React.FC<FlexProps> = ({
  className,
  fullWidth,
  fullHeight,
  mode = "flex",
  direction = "row",
  justify,
  items,
  flexWrap,
  children,
  spacing,
  asContainer = false,
  center,
}) => {
  return (
    <div
      className={cn(
        mode,
        center && "justify-center items-center",
        fullWidth && "w-full",
        fullHeight && "h-full",
        direction && `flex-${direction}`,
        justify && getFlexJustify(justify),
        items && getFlexItems(items),
        flexWrap && `flex-${flexWrap}`,
        spacing && getSpacing({ size: spacing, type: "gap" }),
        asContainer && "container mx-auto",
        className
      )}
    >
      {children}
    </div>
  );
};

export default Flex;
